import React from 'react';
import { MessageCircle } from 'lucide-react';

const FloatingContactButton = () => {
  const scrollToForm = () => {
    document.getElementById('lead-form')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <button
      onClick={scrollToForm}
      aria-label="Jetzt Kontakt aufnehmen"
      className="
        fixed z-50 
        bottom-5 right-5 
        sm:bottom-6 sm:right-6
        flex items-center gap-2
        bg-cyan-700 hover:bg-cyan-800 
        text-white font-medium
        px-4 py-3 sm:px-5 sm:py-3.5
        rounded-full
        shadow-lg hover:shadow-xl
        transition-all duration-300
        focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:ring-offset-2
      "
      style={{
        paddingBottom: 'max(0.75rem, env(safe-area-inset-bottom, 0.75rem))',
      }}
    >
      <MessageCircle className="w-4 h-4 sm:w-5 sm:h-5 flex-shrink-0" />
      <span className="text-sm sm:text-base whitespace-nowrap">Kontakt aufnehmen</span>
    </button>
  );
};

export default FloatingContactButton;
